import { ConfigProvider } from 'antd';
import Router from './components/router';

function App() {
    return(
      <ConfigProvider>
          <Router />
      </ConfigProvider>
    )
}

export default App;